import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";

const functions = getFunctions();

export const authorizeAtlassian = () => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
        throw new Error("User not authenticated.");
    }

    const authUrl = `https://us-central1-${functions.app.options.projectId}.cloudfunctions.net/atlassianAuth?state=${user.uid}`;
    window.open(authUrl, "_blank", "width=800,height=600");
};

export const getJiraProjects = async () => {
    const getJiraProjectsCallable = httpsCallable(functions, "getJiraProjects");
    try {
        const result = await getJiraProjectsCallable();
        return result.data;
    } catch (error) {
        console.error("Error getting Jira projects:", error);
        throw error;
    }
};

export const getJiraEpics = async (projectId) => {
    const getJiraEpicsCallable = httpsCallable(functions, "getJiraEpics");
    try {
        const result = await getJiraEpicsCallable({ projectId });
        return result.data;
    } catch (error) {
        console.error("Error getting Jira epics:", error);
        throw error;
    }
};

export const getJiraSprints = async (projectId) => {
    const getJiraSprintsCallable = httpsCallable(functions, "getJiraSprints");
    try {
        const result = await getJiraSprintsCallable({ projectId });
        return result.data;
    } catch (error) {
        console.error("Error getting Jira sprints:", error);
        throw error;
    }
};

export const createJiraIssue = async (title, content, projectId, epicId, sprintId) => {
    const createJiraIssueCallable = httpsCallable(functions, "createJiraIssue");
    try {
        const result = await createJiraIssueCallable({ title, content, projectId, epicId, sprintId });
        return result.data;
    } catch (error) {
        console.error("Error creating Jira issue:", error);
        throw error;
    }
};

export const createConfluencePage = async (title, content, spaceId) => {
    const createConfluencePageCallable = httpsCallable(functions, "createConfluencePage");
    try {
        const result = await createConfluencePageCallable({ title, content, spaceId });
        return result.data;
    } catch (error) {
        console.error("Error creating Confluence page:", error);
        throw error;
    }
};
